import {useEffect} from "react";

export default function LogoutComponent(){
    useEffect(()=>{
        window.location.replace(process.env.REACT_APP_LOGOUT_REDIRECT!);
    }, [])
    return(
        <></>
    )
}